import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {
    //redirect on refresh button.
    if (window.location.pathname != "/") {
      localStorage.removeItem('redirectUrl');
      localStorage.setItem('redirectUrl', window.location.pathname);
      this.router.navigate([window.location.pathname]);
    }    
  }

  ngOnInit(): void {        
  }
}
